import {type RestTypeWithTypename} from '../rest-type-with-typename';
import {type TagsResponse} from './tags-query-data';

export function tagsTypePatcher(data: TagsResponse): RestTypeWithTypename<TagsResponse> {
    return {
        __typename: 'TagssData',
        ...data,
    };
}
